<template>
    <div class="discount-modal">
        <header v-if="discountIsValid" class="modal-header success d-flex">
            <UIIcon name="check-circle"></UIIcon>
            <div class="title pl-2">{{ translate('title') }}</div>
        </header>
        <header v-if="!discountIsValid" class="modal-header info d-flex">
            <UIIcon name="times-circle"></UIIcon>
            <div class="title pl-2">{{ translate('invalid.title') }}</div>
        </header>

        <div class="discount-modal-content">
            <p>
                {{ translate('yourCode') }}:
                <strong v-if="discountCode" class="code">{{ discountCode }}</strong>
            </p>

            <p
                v-if="discount.percentage"
                class="discount-msg"
                v-html="
                    translate('percentage', {
                        percent: discount.percentage,
                        value: (100 / discount.percentage) * discount.amountPercentageMax,
                        currency: $locale.currency,
                    })
                "
            ></p>

            <p v-if="discountIsValid">
                {{ translate('viewInCart') }}
            </p>
            <p v-if="!discountIsValid">
                {{ translate('invalid.text') }}
            </p>

            <hr />
            <UIButton variant="primary" class="float-right continue" @click="confirm">
                {{ translate('button.continueStep') }}
            </UIButton>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { UIButton, UIIcon } from '@dundle/ui/components';
import TranslationMixin from '~/mixins/TranslationMixin';

export default {
    components: {
        UIButton,
        UIIcon,
    },
    mixins: [TranslationMixin],

    computed: {
        ...mapGetters({
            discountCode: 'cart/getDiscountCode',
            discount: 'cart/getDiscount',
            discountIsValid: 'cart/getDiscountIsValid',
        }),
    },

    methods: {
        ...mapActions({
            hideModal: 'ui/hideModal',
        }),

        confirm() {
            this.hideModal();
        },
    },
};
</script>

<style lang="scss" scoped>
.continue {
    min-width: 10rem;
}

.x-icon {
    margin-top: 0.1rem;
}

.discount-modal-content {
    margin: 1rem -1rem 0 -1rem;
    width: calc(100% + 2rem);

    .code {
        text-transform: uppercase;
    }

    button {
        margin-bottom: -1rem;

        @media screen and (max-width: 767px) {
            width: 100%;
        }
    }
}
</style>
<i18n src="@dundle/locale/data/buttons.json"></i18n>
<i18n></i18n>
